// extracted by mini-css-extract-plugin
export default {"container":"BY-z","list":"CY-z"};